import React from 'react';

const FormField = ({ label, hint, children }) => (
  <label className="form-field">
    {label ? <span className="form-field__label">{label}</span> : null}
    {children}
    {hint ? <span className="form-field__hint">{hint}</span> : null}
  </label>
);

export default FormField;
